import React from 'react';

import {Typography, Box, TextField, Card, CardContent, Button, Grid} from '@material-ui/core/';
import { Alert } from '@material-ui/lab';

class NotPartnerCalculator extends React.Component{
    constructor(props){
        super(props);
        this.state={
            formSubmitted:false,
            name:""
        }
        this.handleSubmit = this.handleSubmit.bind(this)
    }

    handleSubmit(event){
        event.preventDefault()
        this.setState({formSubmitted:true})
    }

    render(){
        return(
        <Box p={3}>
            <Typography variant='h3' gutterBottom>GrubHub is<strong> not </strong>your ally</Typography>
            <Box mt={3}>
            <Typography variant='h5' align='left'  gutterBottom>GrubHub charges <strong>absurd fees and commissions</strong>, hiding them in confusing financial statements.</Typography>
            </Box>
            <Box mt={3}>
            <Typography variant='h5' align='left' gutterBottom>We wrote an open letter on behalf of restaurants like yours who have been taken advantage of by Grubhub’s sky-high commissions. <strong>Please <a href='https://www.gigworkerscollective.org'>sign it</a> and share to help it gain traction</strong>!  
            </Typography>
            </Box>
            <Box mt={3}>
            <Typography variant='h5' align='left' gutterBottom>If you work with Uber Eats, Postmates, or Doordash, 
                            <strong> we want to hear from you. </strong>
                            Fill out your details below if you would like to be contacted by a member of Gig Workers Colletive.
            </Typography>
            </Box>
            <div style={{ display:'flex', justifyContent:'center'}}>
            <Box m={5}>
            <Card style ={{ align: 'center'}}>
            <CardContent>
            <Typography variant='h5' gutterBottom>Share your Story</Typography>
            <form onSubmit={this.handleSubmit}>
            <Grid container spacing={2}>
            <Grid item xs={12}>
                <TextField
                value={this.state.name}
                onChange={(e) => this.setState({formSubmitted: false, name:e.target.value})}
                variant="outlined"
                margin="normal"
                required
                label="Name"
                name="email"
                autoFocus
                />
            </Grid>
            <Grid item xs={12}>
                <TextField
                variant="outlined"
                onChange={() => this.setState({formSubmitted:false})}
                margin="normal"
                required
                label="Email Address"
                name="email"
                autoFocus
                />
            </Grid>
            <Grid item xs={12}>
                <Button type="submit" variant="contained" color="primary">Contact Me</Button>
            </Grid>
            </Grid>
            </form>
            { this.state.formSubmitted && 
            <Box mt={5}>
            <Alert severity="success">
            Thanks {this.state.name.split(" ")[0]}! You'll be contacted soon.
            </Alert>
            </Box>
            }
            </CardContent>
            </Card>
            </Box>
            </div>
        </Box>
        );
    }
}

export default NotPartnerCalculator;